var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { AuthenticationProviderTokenHelpers } from "./AuthenticationProvider";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export var AuthenticationContext = React.createContext({ currentToken: null, currentTokenExpiration: null, authenticated: false, tokenStorageKey: '', establishSession: function (tokenValue) { }, destroySession: function () { }, verifySession: function () { return true; } });
export var useAuth = function () {
    return React.useContext(AuthenticationContext);
};
export var useAuthInContext = function (securityContext) {
    var context = React.useContext(AuthenticationContext);
    var contextToken = sessionStorage.getItem(context.tokenStorageKey + '.' + securityContext);
    if (!contextToken)
        return context;
    var helpers = new AuthenticationProviderTokenHelpers(contextToken);
    return __assign(__assign({}, context), { currentToken: contextToken, currentTokenExpiration: helpers.getTokenExpiration() });
};
